
import { Brain, Sparkles, Leaf, Clock } from "lucide-react";

const features = [
  {
    icon: <Brain className="w-6 h-6 text-solr-nebula-purple" />,
    title: "Neural Enhancement",
    description: "Our nootropic blends support neurotransmitter function and neural connectivity for improved cognitive performance."
  },
  {
    icon: <Sparkles className="w-6 h-6 text-solr-electric-blue" />,
    title: "Cosmic Energy",
    description: "Experience clean, sustained energy without jitters or crashes, inspired by the boundless energy of the cosmos."
  },
  {
    icon: <Leaf className="w-6 h-6 text-solr-aurora-green" />,
    title: "Adaptogenic Balance",
    description: "Premium adaptogens help your body manage stress while supporting overall neural and physical wellbeing."
  },
  {
    icon: <Clock className="w-6 h-6 text-solr-synapse-gold" />,
    title: "Sustained Focus",
    description: "Maintain peak mental performance throughout your day with our carefully crafted nootropic formulations."
  }
];

const FeaturesSection = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            The Science of <span className="neural-text">Neural Clarity</span>
          </h2>
          <p className="text-solr-starfield-silver">
            Our beverages combine ancient wisdom with cutting-edge neuroscience to create 
            formulations that enhance your cognitive function and neural performance.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="cosmic-card p-8 relative group hover:-translate-y-1 transition-all duration-300"
            >
              {/* Neural connection */}
              <div className="absolute -bottom-[1px] left-0 w-0 neural-connection group-hover:w-full transition-all duration-700"></div>
              
              <div className="relative z-10 space-y-4">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold">{feature.title}</h3>
                <p className="text-solr-starfield-silver">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
